import { createStore, combineReducers } from 'redux';
import { authSlice } from './auth-slice/auth-slice';
import { predictionSlice } from './prediction-slice/prediction-slice';
import { usermanagementSlice } from './prediction-slice/usermanagement-slice';
import { appSlice } from './app-slice/app';

const reducers = {
  app: appSlice.reducer,
  auth: authSlice.reducer,
  predictions: predictionSlice.reducer,
  usermanagement: usermanagementSlice.reducer
};

export default function configureStore(initialState: object) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const store: any = createStore(createReducer(null), initialState);

  store.asyncReducers = {};

  store.injectReducer = (key: string, asyncReducers: object) => {
    store.asyncReducers[key] = asyncReducers;
    store.replaceReducer(createReducer(store.asyncReducers));
  };

  return store;
}

function createReducer(asyncReducers: object | null) {
  return combineReducers({
    ...reducers,
    ...asyncReducers,
  });
}
